module.exports = __webpack_public_path__ + "cf1aa983dda2ba5cb318c9334ac92280.MP3";